(() => {
  const setup = (root = document) => {
    const toggle = root.querySelector('.eq-menu-toggle');
    const nav = root.querySelector('.eq-nav');
    if (toggle && nav && !toggle.dataset.ready) {
      toggle.dataset.ready = 'true';
      const close = () => { toggle.setAttribute('aria-expanded', 'false'); toggle.setAttribute('aria-label', toggle.dataset.openLabel); nav.classList.remove('is-open'); };
      toggle.addEventListener('click', () => { const open = toggle.getAttribute('aria-expanded') !== 'true'; toggle.setAttribute('aria-expanded', String(open)); toggle.setAttribute('aria-label', open ? toggle.dataset.closeLabel : toggle.dataset.openLabel); nav.classList.toggle('is-open', open); });
      nav.addEventListener('click', (event) => { if (event.target.closest('a')) close(); });
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') { close(); toggle.focus(); } });
      document.addEventListener('click', (event) => { if (!event.target.closest('.eq-header')) close(); });
      window.matchMedia('(min-width: 800px)').addEventListener('change', close);
    }
    root.querySelectorAll('.eq-menu').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const filter = menu.querySelector('.eq-filter');
      const categories = menu.querySelector('.eq-category');
      filter.hidden = false;
      if (categories) categories.hidden = false;
      let diet = 'all';
      let category = 'all';
      const updateMenu = () => {
        let visibleCards = 0;
        menu.querySelectorAll('[data-eq-card]').forEach(card => {
          let shown = 0;
          card.querySelectorAll('[data-eq-diet]').forEach(row => {
            const visible = diet === 'all' || row.dataset.eqDiet === diet;
            row.hidden = !visible;
            if (visible) shown++;
          });
          card.querySelectorAll('[data-eq-nutrition-diet]').forEach(row => { row.hidden = diet !== 'all' && row.dataset.eqNutritionDiet !== diet; });
          card.hidden = shown === 0 || (category !== 'all' && card.dataset.eqCategoryCard !== category);
          if (!card.hidden) visibleCards++;
        });
        const empty = menu.querySelector('.eq-menu-empty');
        if (empty) empty.hidden = visibleCards > 0;
      };
      filter.addEventListener('click', event => {
        const button = event.target.closest('[data-eq-filter]');
        if (!button) return;
        diet = button.dataset.eqFilter;
        filter.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        updateMenu();
      });
      if (categories) categories.addEventListener('click', event => {
        const button = event.target.closest('[data-eq-category]');
        if (!button) return;
        category = button.dataset.eqCategory;
        categories.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        updateMenu();
      });
      updateMenu();
    });
    root.querySelectorAll('.eq-plans').forEach(plans => {
      const source = plans.querySelector('[data-eq-plan-prices]');
      if (!source || plans.dataset.ready) return;
      plans.dataset.ready = 'true';
      const prices = JSON.parse(source.textContent);
      const controls = plans.querySelector('[data-eq-plan-controls]');
      controls.hidden = false;
      let duration = 0;
      const slot = plans.querySelector('#eq-plan-slot');
      const preference = plans.querySelector('#eq-plan-preference');
      const update = () => {
        const weeks = [1,2,4][duration];
        plans.querySelectorAll('[data-eq-plan]').forEach(card => {
          const tier = card.dataset.eqPlan;
          const pref = tier === 'Night' ? 'Veg' : preference.value;
          const delivery = tier === 'Night' ? 'night' : slot.value;
          const value = prices[tier][pref][delivery][duration];
          const slotLabel = delivery === 'night' ? 'Veg dinner' : delivery === 'both' ? 'Lunch + veg dinner' : 'Lunch';
          const days = weeks * 7;
          const meals = delivery === 'both' ? days * 2 : days;
          const selection = `${pref === 'NonVeg' ? 'Chicken' : pref === 'Veg' && tier !== 'Night' ? 'Paneer' : pref} · ${meals} meals`;
          card.querySelector('[data-eq-plan-price]').textContent = `₹${value.toLocaleString('en-IN')}`;
          card.querySelector('[data-eq-plan-selection]').textContent = selection;
          const variants = JSON.parse(card.querySelector('[data-eq-plan-variants]')?.textContent || '[]') || [];
          const option1 = tier === 'Night' ? 'Veg' : pref === 'NonVeg' ? 'NonVeg · Chicken' : pref === 'Veg' ? 'Veg · Paneer' : 'Egg';
          const option2 = delivery === 'night' ? 'Vegetarian dinner' : delivery === 'both' ? 'Lunch + vegetarian dinner' : 'Lunch';
          const option3 = `${weeks} ${weeks === 1 ? 'week' : 'weeks'} · ${days} days`;
          const variant = variants.find(item => item.option1 === option1 && item.option2 === option2 && item.option3 === option3);
          const link = card.querySelector('[data-eq-plan-link]');
          if (variant && link) {
            const url = new URL(link.href, location.origin);
            url.searchParams.set('variant', variant.id);
            link.href = url.toString();
            card.querySelector('[data-eq-plan-price]').textContent = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(variant.price / 100);
          }
        });
      };
      controls.addEventListener('click', event => { const button = event.target.closest('[data-eq-weeks]'); if (!button) return; duration = Number(button.dataset.eqWeeks); controls.querySelectorAll('[data-eq-weeks]').forEach(item => item.setAttribute('aria-pressed', String(item === button))); update(); });
      slot.addEventListener('change', update);
      preference.addEventListener('change', update);
      update();
    });
    const form = root.querySelector('#EquiBowlContact');
    if (form && !form.dataset.ready) {
      form.dataset.ready = 'true';
      const params = new URLSearchParams(location.search);
      const topic = params.get('topic');
      if (['order','plan','ingredients','other'].includes(topic)) form.querySelector('#eq-topic').value = topic;
      const bowl = params.get('bowl');
      const message = form.querySelector('#eq-message');
      if (bowl && !message.value.trim()) message.value = bowl.slice(0, 150);
    }
  };
  setup();
  document.addEventListener('shopify:section:load', () => setup());
  window.addEventListener('pageshow', () => setup());
})();



